import React from "react";
import { Box, Skeleton, Stack, useTheme } from "@mui/material";

const StepperSkeleton: React.FC = () => {
  const theme = useTheme();

  const steps = Array.from({ length: 4 });

  return (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={theme.nawy.spacing.xxxs}
        sx={{ width: "100%" }}
      >
        {steps.map((_, idx) => (
          <React.Fragment key={idx}>
            <Stack
              direction="column"
              alignItems="center"
              spacing={theme.nawy.spacing.xxs}
              sx={{ flexShrink: 0 }}
            >
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={50} height={14} />
            </Stack>

            {idx < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  minWidth: theme.nawy.spacing.sm,
                  height: "1px",
                  backgroundColor: theme.nawy.colors.semantic.border.secondary,
                  opacity: 0.5,
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Stack>
    </Box>
  );
};

export default StepperSkeleton;
